import { format, parseISO } from "date-fns";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";

import { FunnelIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import profile_img from "../../../assets/avatar_placeholder.svg";
import defaultImage from "../../../assets/defaultImage.svg";
import greenlocation from "../../../assets/greenlocation.svg";
import greentime from "../../../assets/greentime.svg";
import { TwButton, TwListBox, TwRating } from "../../../components/tailwind";
import { cutString } from "../../../helpers";
import { userState } from "../../../redux/reducers/userReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import { bookingStatusFilter } from "../../../utils/constants";
import SessionBookingPopover from "./SessionBookingPopover";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function SessionBooking({
  sessionDataToDisplay,
  displayHeader,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const dashboardReduxState = useSelector(dashboardState);
  const [listLoading, setListLoading] = React.useState(false);
  const [bookingFilter, setBookingFilter] = React.useState('all');
  const [recentBookingsList, setRecentBookingsList] = React.useState([]);
  const [showViewMore, setShowViewMore] = React.useState(false);
  const [recentBookingsPageNumber, setRecentBookingsPageNumber] = React.useState(1);

  /* React.useEffect(() => {
    getRecentBookings();
  }, []); */
  React.useEffect(() => {
    getRecentBookings(recentBookingsPageNumber);
  }, [recentBookingsPageNumber, bookingFilter, dashboardReduxState.updateSessionComp]);

  const getRecentBookings = async (page = 1) => {
    setShowViewMore(false);
    setListLoading(true);
    const manageClassesConfig = {
      method: "get",
      url: `${getUrlForBookings()}getMybookings?scheduleClassId=${sessionDataToDisplay._id}&page=${page}&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`,
    };
    const manageClassesRequest = await axiosInstance(manageClassesConfig);
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.data.data.length) {
        setShowViewMore(true);
        console.log("recentBookingsPageNumber", recentBookingsPageNumber);
        if (recentBookingsPageNumber > 1) {
          console.log([...recentBookingsList, manageClassesRequest.data.data.data]);
          setRecentBookingsList([...recentBookingsList, ...manageClassesRequest.data.data.data]);
        } else {
          setRecentBookingsList(manageClassesRequest.data.data.data);
        }
      }
    }
    setListLoading(false);
  };

  const calculateBoughtTickets = (row) => {
    let totalBookedTickets = 0;

    if (row && row?.ticketsBought?.length) {
      row?.ticketsBought.forEach((item) => {
        totalBookedTickets = totalBookedTickets + parseInt(item.bookingQty)
      })
    }

    return totalBookedTickets
  }

  const ticketAmount = (row) => {
    let amountPaid = "";

    if (row && row?.paymentMethod === "classPass" && row?.passVoucherCode) {
      amountPaid = `${calculateBoughtTickets(row)} Credit`
    } else if (row && row?.ticketsBought?.length) {
      row?.ticketsBought.forEach((item) => {
        amountPaid = `€${parseFloat(parseFloat(item?.ticketAmount ? item?.ticketAmount : 0)).toFixed(2)} `
      })
    }

    return amountPaid
  }

  const getPaymentStatus = (row) => {
    let paymentStatus = row.paymentStatus;
    if (row && row.paymentStatus.toLowerCase() === "paid" && row?.paymentMethod === "classPass" && row?.passVoucherCode) {
      paymentStatus = cutString(row?.purchase_voucher_detail?.selectedPassDetail?.passName || "", 20, true)
    } else if (row && row.paymentStatus.toLowerCase() === "paid") {
      paymentStatus = `Paid Online`
    }

    return paymentStatus
  }
  const handleFilterChange = (event) => {
    const { target: { value } } = event;
    setRecentBookingsPageNumber(1)
    setBookingFilter(value);
    setRecentBookingsList([])
  };
  // console.log("SessionBooking", sessionDataToDisplay);

  return (
    <div className={""}>
      {displayHeader ? (<dev className="flex flex-col gap-3 w-full">
        <dev className="flex flex-col sm:flex-row gap-5">
          <div className="flex flex-auto flex-col gap-2">
            <div className={"w-full h-44 md:h-72 flex justify-center"}>
              {sessionDataToDisplay.classId.classPhoto ? (
                <img
                  className={
                    "sm:h-60 lg:h-72 rounded-2xl"
                  }
                  src={sessionDataToDisplay.classId.classPhoto}
                  alt={""}
                />
              ) : (<img
                className={
                  "w-full sm:h-60 lg:h-72 object-cover rounded-2xl"
                }
                src={defaultImage}
                alt={""}
              />)}
            </div>
            <div className={"grow"}>
              <h2 className={"font-bold text-xl md:text-3xl text-brown-coffee"}>
                {sessionDataToDisplay.className}
              </h2>
              <p className={"text-sm md:text-base"}>
                {sessionDataToDisplay.classId.tagLines}
              </p>
              {(sessionDataToDisplay.scheduleName !== "") ? (<h4 className={"font-bold text-base md:text-xl text-portland-orange"}>{sessionDataToDisplay.scheduleName}</h4>) : ""}
              <div
                className={
                  "min-w-40 flex gap-2 items-left bg-white rounded-lg"
                }
              >
                <TwRating
                  rating={sessionDataToDisplay.classId.rating}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-auto flex-col gap-6 justify-center items-left ">
            <div className="flex justify-center items-center md:w-4/5">
              <div className="flex-none">
                <img
                  className={""}
                  src={greenlocation}
                  alt={""}
                />
              </div>
              <div className="flex-1 pl-2">
                <div className="text-gray-500 text-sm">Where </div>
                <div className="text-black text-base">
                  <p className="font-bold">{sessionDataToDisplay && sessionDataToDisplay.location ? sessionDataToDisplay.location.addressName : ""}</p>
                  <p>{sessionDataToDisplay && sessionDataToDisplay.location ? sessionDataToDisplay.location.address : ""}</p>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center md:w-4/5">
              <div className="flex-none">
                <img
                  className={""}
                  src={greentime}
                  alt={""}
                />
              </div>
              <div className="flex-1 pl-2">
                <div className="text-gray-500 text-sm">When </div>
                <div className="text-black text-base">
                  {sessionDataToDisplay.classDate ? format(parseISO(sessionDataToDisplay.classDate), "EEEE, MMMM d 'at' hh:mm aa") + " - " + format(parseISO(sessionDataToDisplay.classEndDate), "hh:mm aa") : ""}
                </div>
              </div>
            </div>
          </div>
        </dev>
      </dev>) : ""}
      <div
        className={`max-w-7xl min-h-[500px] px-5 py-5 bg-white rounded-lg border-2 border-bright-gray hover:border-indigo-bz ${displayHeader ? "mt-16" : "mt-0"}`}
      >
        <div className="flex gap-2 justify-end items-center mb-10">
          <TwButton variant={"default"} onClick={() => {
            if (recentBookingsPageNumber === 1) {
              getRecentBookings(recentBookingsPageNumber);
            }
            setRecentBookingsPageNumber(1);

          }}>
            <ArrowPathIcon aria-hidden="true" className="size-5 text-brown-coffee forced-colors:text-[Highlight]" />
          </TwButton>
          <TwListBox
            value={bookingFilter}
            options={bookingStatusFilter}
            dropdownArrow={(<FunnelIcon aria-hidden="true" className="size-5 text-brown-coffee forced-colors:text-[Highlight]" />)}
            onChange={(v) => {
              handleFilterChange({ target: { value: v.value } })
            }}
          />
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="">
              <tr className="text-center">
                <th scope="col" className="py-3.5 pl-4 pr-3 text-center text-base font-extrabold text-gray-900 sm:pl-6 truncate">
                  CUSTOMER
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                  BOOKING ID
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                  ACTIVITY BOOKED
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                  SEATS BOOKED
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-base font-extrabold text-gray-900 truncate">
                  AMOUNT PAID
                </th>
                <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900"></th>
              </tr>
            </thead>
            <tbody className="divide-y-8 !border-y-0 divide-white ">
              {listLoading ? (
                <tr>
                  <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                    Loading...
                  </td>
                </tr>
              ) : recentBookingsList.length ? recentBookingsList.map((row, i) => (
                <tr key={i} className="bz-td-row">
                  <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold rounded-l-2xl">
                    <div className="flex justify-center items-center min-w-4/5">
                      <div className="flex-none">
                        {row?.student_detail?.profilePic ? (<img
                          className="size-8 rounded-full mr-3"
                          src={row.student_detail.profilePic}
                          alt={``}
                        />) : (<img
                          className="size-8 rounded-full mr-3"
                          src={profile_img}
                          alt={``}
                        />)}
                      </div>
                      <div className="w-28">
                        {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                        <div>{cutString(row?.student_detail?.fullName, 10, true)}</div>
                        <div className="text-indigo-bz">{cutString((row.student_detail?.countryCode ? row.student_detail.countryCode + "_" + row.student_detail.phoneNumber : "" + row?.student_detail?.username), 10, true)}</div>
                      </div>
                    </div>
                  </td>
                  <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                    {row.bookingId}
                    <p className="text-xs text-gray-400 font-normal text-wrap"><span className={`${(row.status === "Cancelled") ? "text-bz-status-red" : "text-bz-status-green"}`}>{row.status}</span> | {moment(row.bookingDate).format("MMM D")}</p>
                  </td>
                  <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                    {row.className}
                    <p className="text-xs text-gray-400 font-normal text-wrap">{row.schedule_class_detail && row.schedule_class_detail.classDate ? moment(row.schedule_class_detail.classDate).format('MMM D, hh:mm A') : ""}</p>
                  </td>
                  <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                    {row.bookingQty ? row.bookingQty : "1"}
                    <p className="text-xs text-gray-400 font-normal text-wrap" title={row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                      return ticket.bookingQty + " x " + ticket.ticketType + " "
                    }).join(" | ") : ""}>
                      {cutString(row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                        return ticket.bookingQty + " x " + ticket.ticketType + " "
                      }).join(" | ") : "", 25, true)}
                    </p>
                  </td>
                  <td className="bg-white whitespace-nowrap px-3 py-4 text-left text-sm font-bold">
                    {ticketAmount(row)}
                    <p className="text-xs text-gray-400 font-normal text-wrap">{getPaymentStatus(row)}</p>
                  </td>
                  <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-sm font-bold rounded-r-2xl">
                    <SessionBookingPopover
                      bookingDetails={row}
                      handleUpdate={() => {
                        getRecentBookings(recentBookingsPageNumber)
                        return dispatch(
                          dashboardActions.setUpdateSessionComp(
                            dashboardReduxState.updateSessionComp + 1
                          )
                        )
                      }}
                    />
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={6} className="bg-td-row hover:bg-td-row-h whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center rounded-2xl">
                    There is no {bookingFilter !== "all" ? bookingFilter + " " : ""}bookings
                  </td>
                </tr>
              )}

            </tbody>
          </table>
        </div>
        {showViewMore ? (<div className={"flex flex-row justify-center my-4"}>
          <button
            className={
              "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
            }
            onClick={() => {
              setRecentBookingsPageNumber(recentBookingsPageNumber + 1);
            }}
          >
            View More
          </button>
        </div>) : ""}
      </div>
    </div>
  );
}
